// Libs
import React, { Fragment, useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Pagination } from "react-bootstrap";

// Action
import { getNotifications, setNotificationAsViewed } from "../module/feeds";

// Components
import { default as Loadable } from "../../components/_Shared/commonLoadable";
import NotificationContent from "../component/notificationCenter/NotificationContent";

// Images
import noNotificationIcon from "../images/no-notifications.png";

// Style
import "./AllNotifications.css";

const AllNotifications = ({
  notifications,
  isFetching,
  totalPages,
  unreadNotifications,
  setNotificationAsViewed,
  getNotifications
}) => {
  const [activePage, setActivePage] = useState(1);

  // Set notifications as read
  useEffect(
    () => {
      if (unreadNotifications.length > 0) {
        setNotificationAsViewed(unreadNotifications);
      }
    },
    [unreadNotifications]
  );

  const handlePageSelect = page => {
    getNotifications({ page });
    setActivePage(page);
  };

  return (
    <Loadable active={isFetching}>
      <Fragment>
        <h2 className="title-header">Notification Center</h2>
        {notifications.map(notification => {
          return <NotificationContent notification={notification} />;
        })}
        {notifications.length > 0 ? (
          <div className="AllNotifications__footer">
            <Pagination
              first
              prev
              ellipsis
              next
              last
              boundaryLinks
              bsSize="small"
              items={totalPages}
              maxButtons={5}
              activePage={activePage}
              onSelect={page => handlePageSelect(page)}
            />
          </div>
        ) : (
          <div className="AllNotifications__content-no-notification">
            <img src={noNotificationIcon} alt="Nothing to see here" />
            Nothing to See Here!
          </div>
        )}
      </Fragment>
    </Loadable>
  );
};

function mapStateToProps(state) {
  const {
    notifications: {
      feed: notifications,
      isFetching,
      totalPages,
      unreadNotifications
    }
  } = state;
  return {
    notifications,
    isFetching,
    totalPages,
    unreadNotifications
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { getNotifications, setNotificationAsViewed },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllNotifications);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/AllNotifications.js